import React, { ReactElement, ReactNode } from 'react';

import useAxiosClients, { AxiosClients } from './axios-clients';

const AxiosClientsContext = React.createContext<AxiosClients>({} as never);

type Props = {
  children: ReactNode;
};

export const AxiosClientsProvider = ({ children }: Readonly<Props>): ReactElement => (
  <AxiosClientsContext.Provider value={useAxiosClients()}>{children}</AxiosClientsContext.Provider>
);

export const useAxiosClientsContextProvider = (): AxiosClients => React.useContext<AxiosClients>(AxiosClientsContext);
